"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEskin = exports.eskinUseableDef = void 0;
const KetteSerieType_1 = require("./KetteSerieType");
const schemaVersions_1 = require("../schemaVersions");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
exports.eskinUseableDef = {
    parent: schemaVersions_1.ketteLatestUseableDef,
    validation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.eskin,
    },
};
exports.isEskin = echain_shared_modelling_1.UseableUtil.createGuard(exports.eskinUseableDef);
//# sourceMappingURL=Eskin.js.map